import React from "react";
import FieldWrapper from "../Common/FieldWrapper";
import purifyHTML from "../../../utils/purifyHTML";

export default class Checkbox extends FieldWrapper {
  renderField() {
    const {
      formikForm,
      formikField,
      isRequired,
      config: { label, name, options, direction, readOnly, disabled },
    } = this.props;

    const listeners = {};
    if (readOnly) {
      listeners.onClick = (e) => {
        e.preventDefault();
      };
    }
    return (
      <div
        role="radiogroup"
        aria-label={label}
        aria-required={!!isRequired}
        className={`field__group ${
          direction === "horizontal" ? "field__group--horizontal" : ""
        }`}
      >
        {options.map(({ label, value }) => (
          <div
            key={`${name}_${value}`}
            className="field__option field__option--radio"
          >
            <input
              className="field__radio"
              type="radio"
              id={`${name}_${value}`}
              value={value}
              checked={formikField.value === value} //formikField.value && formikField.value.indexOf(value) !== -1}
              disabled={!!disabled}
              aria-label={label}
              {...formikField}
              onChange={() => {
                formikForm.setFieldValue(name, value);
              }}
              {...listeners}
            />
            <label
              htmlFor={`${name}_${value}`}
              className="field__option-label"
              dangerouslySetInnerHTML={purifyHTML(label)}
              {...listeners}
            />
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/RadioGroup.js